const getNorkartData = async (lat, lng, apiKey) => {
  try {
    const response = await fetch(
      `https://takflater.api.norkart.no/takflater/punkt?Y=${lat}&X=${lng}&api_key=${apiKey}&format=json`,
      {
        method: 'GET',
      }
    );
    return await response.json();
  } catch (error) {
    console.warn('Error fetching norkart data: ', error);
  }
};

const getOfferData = async (parameters, headers) => {
  const url = '/api/SunPanel/offers';
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ JsonString: JSON.stringify(parameters) }),
      headers: headers,
    });
    return await response.json();
  } catch (error) {
    console.warn('Error fetching offer data: ', error);
  }
};

const getProductVariants = async (headers) => {
  try {
    const response = await fetch('/api/SunPanel/productlist', {
      method: 'POST',
      headers: headers,
    });
    return await response.json();
  } catch (error) {
    console.warn('Error fetching product variants: ', error);
  }
};

const getRoofTypes = async () => {
  try {
    const response = await fetch('/api/SunPanel/rooftypes', {
      method: 'POST',
    });
    return await response.json();
  } catch (error) {
    console.warn('Error fetching roof data: ', error);
  }
};

const sendFormRequest = async (formData, headers) => {
  try {
    return await fetch('/api/SunPanel/sendrequest', {
      method: 'POST',
      headers: headers,
      body: formData,
      redirect: 'follow',
    });
  } catch (error) {
    console.warn('Error sending request: ', error);
  }
};

export default {
  getNorkartData,
  getOfferData,
  getProductVariants,
  getRoofTypes,
  sendFormRequest,
};
